<template>
  <div class="modal fade" id="editScoreTemplateModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div style="width: 100%">
            <h5>Edit Template</h5>
          </div>
          <div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <ScoreTemplateCreator
            v-bind:ScoreTemplate="ScoreTemplate"
            @cancel-creator="cancel"
            @template-updated="updatedTemplate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ScoreTemplateCreator from "@/components/Score/ScoreTemplateCreator.vue";

export default {
  components: {
    ScoreTemplateCreator
  },
  props: {
    ScoreTemplate: Object
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      $("#editScoreTemplateModal").modal("hide");
    },
    updatedTemplate(updatedTemplate) {
      this.$emit("template-updated", updatedTemplate);
    }
  }
};
</script>
